import { useState, useEffect } from 'react'

// Start time: 10 minutes and 43 seconds in seconds
const INITIAL_TIME = 10 * 60 + 43

export function useSharedTimer() {
  const [timeLeft, setTimeLeft] = useState(INITIAL_TIME)

  useEffect(() => {
    // Check if there's a saved end time in localStorage
    const savedEndTime = localStorage.getItem('offerEndTime')
    let endTime: number

    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10)
    } else {
      // Set new end time
      endTime = Date.now() + INITIAL_TIME * 1000
      localStorage.setItem('offerEndTime', endTime.toString())
    }

    const interval = setInterval(() => {
      const now = Date.now()
      const difference = Math.floor((endTime - now) / 1000)

      if (difference <= 0) {
        setTimeLeft(0)
        clearInterval(interval)
      } else {
        setTimeLeft(difference)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60)
    const s = seconds % 60
    return `00:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }

  return {
    timeLeft,
    formattedTime: formatTime(timeLeft),
    isExpired: timeLeft === 0,
  }
}
